(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lorenzi-drop-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lorenzi-drop-card')) {
    customElements.define(
      'lorenzi-drop-card',
      class extends HTMLElement {
        connectedCallback() {
          const form = this.querySelector('form');
          const trigger = this.querySelector('[data-drop-trigger]');
          if (!form || !trigger) return;

          // Shopify reloads on ?customer_posted=true#<form id> after a successful sign-up
          const posted = new URLSearchParams(window.location.search).get('customer_posted') === 'true';
          if (posted && window.location.hash === `#${form.id}`) {
            this.classList.add('is-done');
            this.querySelector('.lz-drop__note--success')?.removeAttribute('hidden');
            return;
          }

          if (this.querySelector('.lz-drop__note--error')) this.classList.add('is-open');

          trigger.addEventListener('click', () => {
            this.classList.add('is-open');
            this.querySelector('.lz-drop__field')?.focus();
          });
          form.addEventListener('submit', () => this.classList.add('is-sending'));
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
